import type { ReactNode } from 'react';
import { Icono } from './Icono';
import type { NombreIcono } from './iconos';
import './eleccion.css';

/**
 * Tarjeta de elección (patrón de 2.5 a 2.8: «Elige la principal», «¿Tienes prueba…?», «Qué pide», «Tipo»): botón con
 * `role="radio"`, borde `--rv-rule-strong`; elegida, borde rojo y fondo `--rv-red-soft`. Con `icono`, baldosa a la
 * izquierda (roja al elegirla); sin él, el círculo de radio. `bloqueada`: se ve pero no se cambia.
 */
interface Props {
    elegida: boolean;
    onElegir: () => void;
    titulo: ReactNode;
    texto?: ReactNode;
    icono?: NombreIcono;
    bloqueada?: boolean;
    /** Al tocarla bloqueada (p. ej. para decir por qué no se cambia). */
    onBloqueada?: () => void;
    etiqueta?: string;
    children?: ReactNode;
}

export function OpcionRadio({ elegida, onElegir, titulo, texto, icono, bloqueada = false, onBloqueada, etiqueta, children }: Props) {
    return (
        <button
            type="button"
            role="radio"
            aria-checked={elegida}
            aria-label={etiqueta}
            aria-disabled={bloqueada ? true : undefined}
            className={`rv-opcion${elegida ? ' rv-opcion--on' : ''}${bloqueada ? ' rv-opcion--bloqueada' : ''}`}
            onClick={() => {
                if (!bloqueada) {
                    onElegir();
                } else if (!elegida) {
                    onBloqueada?.();
                }
            }}
        >
            {icono === undefined ? (
                <span className="rv-opcion__radio" aria-hidden="true">
                    <span />
                </span>
            ) : (
                <span className="rv-opcion__baldosa" aria-hidden="true">
                    <Icono nombre={icono} />
                </span>
            )}
            <span className="rv-opcion__texto">
                <strong>{titulo}</strong>
                {texto !== undefined && <span>{texto}</span>}
                {children}
            </span>
        </button>
    );
}
